// Independent Gift Wrap System - completely bypasses Shopify's built-in logic

class IndependentGiftWrap extends HTMLElement {
  constructor() {
    super();

    this.miniCart = document.querySelector('mini-cart');
    this.giftWrapId = this.dataset.giftWrapId;
    this.cartItemsSize = parseInt(this.getAttribute('cart-items-size'));
    this.giftWrapsInCart = parseInt(this.getAttribute('gift-wraps-in-cart'));
    this.itemsInCart = parseInt(this.getAttribute('items-in-cart'));
    this.giftWrapPrice = this.dataset.giftWrapPrice || '';
    this.giftWrapText = this.dataset.giftWrapText || 'Add Gift Wrapping';
    
    // Detect if we're in mini-cart context
    this.isMiniCart = this.closest('.mini-cart') !== null || this.closest('form#cart') !== null;
    
    // Our own tracking - independent of Shopify's gift-wrapping attribute
    this.isGiftWrapEnabled = false;
    this.currentGiftWrapQuantity = 0;
    
    this.init();
  }

  init() {
    this.createInterface();
    this.attachEventListeners();
    this.initializeFromCart();
  }

  createInterface() {
    if (this.isMiniCart) {
      this.createMiniCartInterface();
    } else {
      this.createFullInterface();
    }
    
    this.addStyles();
    this.cacheElements();
  }

  createMiniCartInterface() {
    // Create compact interface for mini-cart
    this.innerHTML = `
      <div class="mini-cart-gift-wrap">
  <div class="gift-wrap-single-line">
    <div class="gift-wrap-toggle-compact">
      <input type="checkbox" id="enable-gift-wrap-mini" class="gift-wrap-checkbox">
      <label for="enable-gift-wrap-mini" class="gift-wrap-label-compact">
        <span class="gift-wrapping__text">
          ${this.giftWrapText.replace('[PRICE]', this.giftWrapPrice)}
        </span>
      </label>
    </div>
    
    <div class="gift-wrap-quantity-compact" style="display: none;">
      <div class="quantity-input-mini">
        <button type="button" class="qty-btn-mini qty-minus">-</button>
        <input type="number" id="gift-wrap-qty-mini" class="gift-wrap-qty-input-mini" min="1" max="${this.itemsInCart}" value="1">
        <button type="button" class="qty-btn-mini qty-plus">+</button>
      </div>
    </div>
  </div>
  
  <div class="loading-overlay hidden">
    <span>Updating...</span>
  </div>
</div>
    `;
  }

  createFullInterface() {
    // Create full interface for cart page
    this.innerHTML = `
      <div class="independent-gift-wrap">
        <div class="gift-wrap-toggle">
          <input type="checkbox" id="enable-gift-wrap" class="gift-wrap-checkbox">
          <label for="enable-gift-wrap">
            <span class="gift-wrapping__text">
              ${this.giftWrapText.replace('[PRICE]', this.giftWrapPrice)}
            </span>
          </label>
        </div>
        
        <div class="gift-wrap-quantity-section" style="display: none;">
          <div class="gift-wrap-main-content">
            <div class="quantity-controls">
              <label for="gift-wrap-qty">How many items to gift wrap? If an order has multiple items, and some need ribbon wrapping and some don't, please specify which in the order notes below. Items can be wrapped separately or together as one.</label>
              <div class="quantity-input-group">
                <button type="button" class="qty-btn qty-minus">-</button>
                <input type="number" id="gift-wrap-qty" class="gift-wrap-qty-input" min="1" max="${this.itemsInCart}" value="1">
                <button type="button" class="qty-btn qty-plus">+</button>
              </div>
              <span class="qty-helper">Max: ${this.itemsInCart} items</span>
            </div>
            
            <div class="gift-wrap-images">
              <!-- Gift note template image -->
              <div class="gift-note-image">
                <img src="https://cdn.shopify.com/s/files/1/0710/5278/7987/files/SKYLIT-STUDIO-CUSTOM-MESSAGE-GIFT-NOTE.svg?v=1740057832" alt="Gift Note Template" loading="lazy"/>
              </div>
              
              <!-- Ribbon options image -->
              <div class="gift-note-image">
                <img src="https://cdn.shopify.com/s/files/1/0710/5278/7987/files/P2190804_skylit_studio_ribbon_color_1.webp?v=1739990573" alt="Ribbon Gift Wrap Options" loading="lazy"/>
              </div>
            </div>
          </div>
          
          <div class="gift-wrap-note-section">
            <label for="gift-note">Gift message (optional):</label>
            <textarea id="gift-note" class="gift-note-input" placeholder="Enter your gift message... Please write as From: xx Message: xx" rows="3"></textarea>
          </div>
        </div>
        
        <div class="loading-overlay hidden">
          <span>Updating cart...</span>
        </div>
      </div>
    `;
  }

  cacheElements() {
    // Cache elements based on context
    if (this.isMiniCart) {
      this.checkbox = this.querySelector('.gift-wrap-checkbox');
      this.quantitySection = this.querySelector('.gift-wrap-quantity-compact');
      this.quantityInput = this.querySelector('.gift-wrap-qty-input-mini');
      this.minusBtn = this.querySelector('.qty-minus');
      this.plusBtn = this.querySelector('.qty-plus');
      this.noteInput = null; // No note input in mini-cart
      this.loadingOverlay = this.querySelector('.loading-overlay');
    } else {
      this.checkbox = this.querySelector('.gift-wrap-checkbox');
      this.quantitySection = this.querySelector('.gift-wrap-quantity-section');
      this.quantityInput = this.querySelector('.gift-wrap-qty-input');
      this.minusBtn = this.querySelector('.qty-minus');
      this.plusBtn = this.querySelector('.qty-plus');
      this.noteInput = this.querySelector('.gift-note-input');
      this.loadingOverlay = this.querySelector('.loading-overlay');
    }
  }

  addStyles() {
    if (this.isMiniCart) {
      this.addMiniCartStyles();
    } else {
      this.addFullStyles();
    }
  }

  addMiniCartStyles() {
    if (document.getElementById('mini-cart-gift-wrap-styles')) return;
    
    const style = document.createElement('style');
    style.id = 'mini-cart-gift-wrap-styles';
    style.textContent = `
      .mini-cart-gift-wrap {
  border-top: 1px solid #e0e0e0;
  background: #f9f9f9;
  border-radius: 6px;
  position: relative;
  margin-left: -10px;
  margin-right: -10px;
  padding: 10px 12px;
}

.gift-wrap-single-line {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: nowrap;
}

.gift-wrap-toggle-compact {
  flex: 1;
  min-width: 0;
  display: flex;
}

.gift-wrap-toggle-compact input[type="checkbox"] {
  flex-shrink: 0;
  vertical-align: baseline;
  margin-top: 1px;
}

.gift-wrap-label-compact {
  font-size: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  line-height: 1.3;
  font-weight: 500;
}

.gift-wrapping__text {
    font-size: 1.1rem;
    padding-left: 5px;
}

.gift-wrap-quantity-compact {
  flex-shrink: 0;
}

.quantity-input-mini {
  display: flex;
  align-items: center;
  gap: 4px;
}

.qty-btn-mini {
  width: 22px;
  height: 22px;
  border: 1px solid #ddd;
  background: white;
  cursor: pointer;
  border-radius: 3px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #555;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.qty-btn-mini:hover:not(:disabled) {
  background: #f5f5f5;
  border-color: #ccc;
}

.qty-btn-mini:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  background: #f9f9f9;
}

.gift-wrap-qty-input-mini {
  width: 35px;
  height: 22px;
  text-align: center;
  border: 1px solid #ddd;
  border-radius: 3px;
  padding: 0 2px;
  font-size: 11px;
  font-weight: 500;
  flex-shrink: 0;
}

.gift-wrap-qty-input-mini:focus {
  outline: none;
  border-color: #C0821D;
  box-shadow: 0 0 0 1px rgba(0, 123, 255, 0.1);
}

.mini-cart-gift-wrap .loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  font-size: 11px;
  color: #666;
  font-weight: 500;
}

.mini-cart-gift-wrap .loading-overlay.hidden {
  display: none;
}
@media (max-width: 768px) {
  .gift-wrapping__text {
    font-size: 1rem;
}
}
    `;
    document.head.appendChild(style);
  }

  addFullStyles() {
    if (document.getElementById('independent-gift-wrap-styles')) return;
    
    const style = document.createElement('style');
    style.id = 'independent-gift-wrap-styles';
    style.textContent = `
      .independent-gift-wrap {
        border: 1px solid #e0e0e0;
        border-radius: 8px;
        padding: 16px;
        margin: 16px 0;
        background: #fafafa;
        position: relative;
        overflow: hidden; /* Optionally hides overflow */
      }
      
      .gift-wrap-toggle {
        margin-bottom: 12px;
        display: flex;
      }
      
      .gift-wrap-toggle label {
        font-weight: 600;
        margin-left: 8px;
        cursor: pointer;
      }

      .gift-wrap-toggle input[type="checkbox"] {
  flex-shrink: 0;
  vertical-align: baseline;
  margin-top: 1px;
}
      
      .gift-wrap-quantity-section {
        margin-left: 24px;
        padding: 12px;
        background: white;
        border-radius: 6px;
        border-left: 3px solid #C0821D;
      }
      
      .quantity-controls {
        margin-bottom: 16px;
      }
      
      .quantity-controls label {
        display: block;
        margin-bottom: 8px;
        font-weight: 500;
      }
      
      .quantity-input-group {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 4px;
      }
      
      .qty-btn {
        width: 32px;
        height: 32px;
        border: 1px solid #ccc;
        background: white;
        cursor: pointer;
        border-radius: 4px;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      
      .qty-btn:hover {
        background: #f0f0f0;
      }
      
      .qty-btn:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
      
      .gift-wrap-qty-input {
        width: 60px;
        height: 32px;
        text-align: center;
        border: 1px solid #ccc;
        border-radius: 4px;
        padding: 0 8px;
      }
      
      .qty-helper {
        font-size: 12px;
        color: #666;
        font-style: italic;
      }
      
      .gift-wrap-note-section label {
        display: block;
        margin-bottom: 6px;
        font-weight: 500;
        font-size: 14px;
      }
      
      .gift-note-input {
        width: 100%;
        padding: 8px;
        border: 1px solid #ccc;
        border-radius: 4px;
        resize: vertical;
        font-family: inherit;
        margin-bottom: 0;
        min-height: 60px;
      }
      
      .gift-wrap-images {
  position: absolute;
  top: 65px;
  right: 35px;
  z-index: 1;
}
      
      .gift-note-image {
        display: inline-block;
        width: auto;
        height: 140px;
        max-width: 280px;
        flex-shrink: 0;
      }
      
      .gift-note-image img {
        width: auto;
        height: 100%;
        max-width: 100%;
        object-fit: contain;
        border-radius: 4px;
        box-shadow: 0 2px 8px rgba(0,0,0,0.1);
        background: white;
        border: 1px solid #e0e0e0;
      }
      
      .loading-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(255, 255, 255, 0.9);
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
        font-weight: 500;
        color: #C0821D;
      }
      
      .loading-overlay.hidden {
        display: none;
      }

      @media (max-width: 768px) {
  .gift-wrap-images {
    position: static;           /* Removes absolute positioning */
    justify-content: center;    /* Centers images */
    margin-top: 12px;          /* Adds space above */
    background: #f8f9fa;       /* Light background */
    border: 1px solid #e9ecef; /* Subtle border */
    display: flex;
    height: 100px;
  }
  .gift-note-image img {
        height: 70%;
  }
}
    `;
    document.head.appendChild(style);
  }

  attachEventListeners() {
    // Main checkbox toggle
    this.checkbox.addEventListener('change', (e) => {
      if (e.target.checked) {
        this.enableGiftWrap();
      } else {
        this.disableGiftWrap();
      }
    });

    // Quantity controls
    this.minusBtn.addEventListener('click', () => {
      const currentValue = parseInt(this.quantityInput.value);
      if (currentValue > 1) {
        this.quantityInput.value = currentValue - 1;
        this.updateGiftWrapQuantity();
      }
    });

    this.plusBtn.addEventListener('click', () => {
      const currentValue = parseInt(this.quantityInput.value);
      if (currentValue < this.itemsInCart) {
        this.quantityInput.value = currentValue + 1;
        this.updateGiftWrapQuantity();
      }
    });

    // Direct quantity input
    let quantityTimeout;
    this.quantityInput.addEventListener('input', () => {
      clearTimeout(quantityTimeout);
      quantityTimeout = setTimeout(() => {
        this.updateGiftWrapQuantity();
      }, 500);
    });

    // Gift note (only for full interface)
    if (this.noteInput) {
      let noteTimeout;
      this.noteInput.addEventListener('input', () => {
        clearTimeout(noteTimeout);
        noteTimeout = setTimeout(() => {
          this.updateGiftNote();
        }, 1000);
      });
    }

    // Sync with legacy gift note popup (in mini-cart)
    this.setupLegacyGiftNoteSync();
  }

  enableGiftWrap() {
    this.isGiftWrapEnabled = true;
    this.quantitySection.style.display = 'block';
    this.quantityInput.value = Math.min(1, this.itemsInCart);
    this.updateQuantityButtons();
    this.addGiftWrapToCart();
  }

  disableGiftWrap() {
    this.isGiftWrapEnabled = false;
    this.quantitySection.style.display = 'none';
    this.removeGiftWrapFromCart();
  }

  updateGiftWrapQuantity() {
    if (!this.isGiftWrapEnabled) return;
    
    const quantity = parseInt(this.quantityInput.value) || 1;
    const clampedQuantity = Math.max(1, Math.min(quantity, this.itemsInCart));
    
    if (quantity !== clampedQuantity) {
      this.quantityInput.value = clampedQuantity;
    }
    
    this.updateQuantityButtons();
    this.addGiftWrapToCart(clampedQuantity);
  }

  updateQuantityButtons() {
    const quantity = parseInt(this.quantityInput.value) || 1;
    this.minusBtn.disabled = quantity <= 1;
    this.plusBtn.disabled = quantity >= this.itemsInCart;
  }

  async addGiftWrapToCart(quantity = 1) {
    this.showLoading();
    
    try {
      const sections = this.getSectionsToRender().map((section) => section.section);
      
      // Use our own custom attributes instead of Shopify's gift-wrapping
      const body = JSON.stringify({
        updates: {
          [this.giftWrapId]: quantity
        },
        attributes: {
          '_addon_gift_wrap_theme': 'regular',
          '_addon_gift_note': this.noteInput ? this.noteInput.value || '' : ''
        },
        sections: sections,
        sections_url: window.location.pathname
      });

      const response = await fetch(`${theme.routes.cart_update_url}`, {
        ...fetchConfig(),
        body
      });
      
      const data = await response.json();
      
      if (response.ok) {
        this.currentGiftWrapQuantity = quantity;
        this.handleCartUpdate(data);
      } else {
        throw new Error('Cart update failed');
      }
      
    } catch (error) {
      console.error('Gift wrap update error:', error);
      this.handleError();
    } finally {
      this.hideLoading();
    }
  }

  async removeGiftWrapFromCart() {
    this.showLoading();
    
    try {
      const sections = this.getSectionsToRender().map((section) => section.section);
      
      const body = JSON.stringify({
        updates: {
          [this.giftWrapId]: 0
        },
        attributes: {
          '_addon_gift_wrap_theme': '',
          '_addon_gift_note': ''
        },
        sections: sections,
        sections_url: window.location.pathname
      });

      const response = await fetch(`${theme.routes.cart_update_url}`, {
        ...fetchConfig(),
        body
      });
      
      const data = await response.json();
      
      if (response.ok) {
        this.currentGiftWrapQuantity = 0;
        this.handleCartUpdate(data);
      } else {
        throw new Error('Cart update failed');
      }
      
    } catch (error) {
      console.error('Gift wrap removal error:', error);
      this.handleError();
    } finally {
      this.hideLoading();
    }
  }

  async updateGiftNote() {
    if (!this.isGiftWrapEnabled || !this.noteInput) return;
    
    try {
      const body = JSON.stringify({
        attributes: {
          '_addon_gift_note': this.noteInput.value || ''
        }
      });

      await fetch(`${theme.routes.cart_update_url}`, {
        ...fetchConfig(),
        body
      });
      
    } catch (error) {
      console.error('Gift note update error:', error);
    }
  }

  initializeFromCart() {
    // Check our custom attributes instead of Shopify's
    const giftWrapEnabled = this.dataset.customGiftWrapEnabled === 'true';
    const giftWrapQuantity = parseInt(this.dataset.customGiftWrapQuantity) || 0;
    const giftNote = this.dataset.customGiftNote || '';
    
    if (giftWrapEnabled && giftWrapQuantity > 0) {
      this.checkbox.checked = true;
      this.isGiftWrapEnabled = true;
      this.currentGiftWrapQuantity = giftWrapQuantity;
      this.quantitySection.style.display = 'block';
      this.quantityInput.value = giftWrapQuantity;
      if (this.noteInput) {
        this.noteInput.value = giftNote;
      }
      this.updateQuantityButtons();
    }
    
    // Also check if there are gift wrap items in cart but our system wasn't initialized
    else if (this.giftWrapsInCart > 0) {
      // Legacy detection - convert to our system
      this.checkbox.checked = true;
      this.isGiftWrapEnabled = true;
      this.currentGiftWrapQuantity = this.giftWrapsInCart;
      this.quantitySection.style.display = 'block';
      this.quantityInput.value = this.giftWrapsInCart;
      this.updateQuantityButtons();
      
      // Update cart with our attributes
      this.addGiftWrapToCart(this.giftWrapsInCart);
    }
  }

  handleCartUpdate(data) {
    if (document.body.classList.contains('template-cart')) {
      window.location.href = theme.routes.cart_url;
      return;
    }

    if (this.miniCart) {
      this.miniCart.renderContents(data);
    }
    
    // Dispatch custom event for other components
    this.dispatchEvent(new CustomEvent('gift-wrap-updated', {
      detail: {
        enabled: this.isGiftWrapEnabled,
        quantity: this.currentGiftWrapQuantity,
        note: this.noteInput ? this.noteInput.value : ''
      },
      bubbles: true
    }));
  }

  handleError() {
    // Reset UI state on error
    this.checkbox.checked = this.currentGiftWrapQuantity > 0;
    this.quantityInput.value = this.currentGiftWrapQuantity || 1;
    
    if (this.currentGiftWrapQuantity > 0) {
      this.quantitySection.style.display = 'block';
    } else {
      this.quantitySection.style.display = 'none';
    }
  }

  showLoading() {
    this.loadingOverlay.classList.remove('hidden');
  }

  hideLoading() {
    this.loadingOverlay.classList.add('hidden');
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      }
    ];
  }

  setupLegacyGiftNoteSync() {
    // Find the legacy gift note textarea in the mini-cart popup
    const legacyGiftNoteTextarea = document.querySelector('#Gift-note, textarea[name="attributes[_addon_gift_note]"]');
    
    if (legacyGiftNoteTextarea) {
      // Sync from legacy to our system
      let legacyNoteTimeout;
      legacyGiftNoteTextarea.addEventListener('input', () => {
        clearTimeout(legacyNoteTimeout);
        legacyNoteTimeout = setTimeout(() => {
          this.syncFromLegacyNote(legacyGiftNoteTextarea.value);
        }, 500);
      });

      // Initial sync on load
      if (legacyGiftNoteTextarea.value && this.isGiftWrapEnabled) {
        this.syncFromLegacyNote(legacyGiftNoteTextarea.value);
      }
    }

    // Also watch for the gift note popup to open/close
    const giftNotePopup = document.querySelector('details:has(#Gift-note)');
    if (giftNotePopup) {
      giftNotePopup.addEventListener('toggle', () => {
        if (giftNotePopup.open) {
          // Popup opened - sync our note to the popup
          this.syncToLegacyNote();
        }
      });
    }
  }

  syncFromLegacyNote(noteValue) {
    // Update our internal tracking
    if (this.noteInput) {
      this.noteInput.value = noteValue;
    }

    // Update cart attributes
    this.updateGiftNoteOnly(noteValue);
  }

  syncToLegacyNote() {
    const legacyGiftNoteTextarea = document.querySelector('#Gift-note, textarea[name="attributes[_addon_gift_note]"]');
    
    if (legacyGiftNoteTextarea) {
      // Get current note value from our system or cart attributes
      const currentNote = this.noteInput ? this.noteInput.value : (this.dataset.customGiftNote || '');
      
      if (currentNote && currentNote !== legacyGiftNoteTextarea.value) {
        legacyGiftNoteTextarea.value = currentNote;
      }
    }
  }

  async updateGiftNoteOnly(noteValue) {
    if (!this.isGiftWrapEnabled) return;
    
    try {
      const body = JSON.stringify({
        attributes: {
          '_addon_gift_note': noteValue || ''
        }
      });

      await fetch(`${theme.routes.cart_update_url}`, {
        ...fetchConfig(),
        body
      });
      
    } catch (error) {
      console.error('Gift note sync error:', error);
    }
  }
}

// Register our independent component. On /cart, cart-addons-upgraded.js has
// usually registered its own version first; defining it twice throws.
if (!customElements.get('independent-gift-wrap')) customElements.define('independent-gift-wrap', IndependentGiftWrap);

// Optional: Keep the original classes for backward compatibility, but make them no-ops
class GiftQuantity extends QuantityInput {
  constructor() {
    super();
  }
  init() {
    super.init();
    // Do nothing - let our independent system handle everything
  }
}

class GiftWrapping extends HTMLElement {
  constructor() {
    super();
    // Do nothing - replaced by IndependentGiftWrap
  }
}

class GiftNote extends HTMLElement {
  constructor() {
    super();
    // Do nothing - handled by IndependentGiftWrap
  }
}

// Keep the registrations to prevent errors
if (!customElements.get('gift-quantity-legacy')) customElements.define('gift-quantity-legacy', GiftQuantity);
if (!customElements.get('gift-wrapping-legacy')) customElements.define('gift-wrapping-legacy', GiftWrapping);
if (!customElements.get('gift-note-legacy')) customElements.define('gift-note-legacy', GiftNote);